window.abTesting.rerenderMainProductSection = function () {
	fetch(window.location.pathname + '?view=vertical-variant-picker')
		.then((res) => res.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const variantPicker = doc.querySelector('[variant-picker-wrapper]');
			const productForm = document.querySelector('[variant-picker-wrapper]');
			productForm.innerHTML = variantPicker.innerHTML;
			const quickAdd = doc.querySelector('product-quick-add');
			const quickAddContainer = document.querySelector('product-quick-add');
			quickAddContainer.parentElement.replaceChild(quickAdd, quickAddContainer);
			productForm.classList.remove('product-section-variant-picker--A');
			productForm.classList.add('product-section-variant-picker--B');
		});
};
window.abTesting.rerenderMainProductGallery = function () {
	fetch(window.location.pathname + '?view=abtesting-alternative-img')
		.then((res) => res.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const newProductGallery = doc.querySelector('product-gallery');
			const oldProductGallery = document.querySelector('product-gallery');
			oldProductGallery.parentElement.replaceChild(newProductGallery, oldProductGallery);
		});
};

class AutoCloseTabs extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.tabs = this.querySelectorAll('details');
		this.initMutationObserver();
		this.addTabsAttributes('autoclose');
	}

	addTabsAttributes(attribute) {
		this.tabs.forEach((tab) => {
			tab.setAttribute(attribute, '');
		});
	}

	initMutationObserver() {
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
					const targetElement = mutation.target;
					if (targetElement.open) {
						this.updateTabs(targetElement);
						setTimeout(() => {
							this.scrollIntoView(targetElement);
						}, 200);
					}
				}
			}
		};
		const observer = new MutationObserver(mutationCallback);
		const observerConfig = {
			attributes: true,
			attributeFilter: ['open'],
		};
		for (const item of this.tabs) {
			observer.observe(item, observerConfig);
		}
	}

	updateTabs(targetElement) {
		this.tabs.forEach((tab) => {
			if (tab !== targetElement) {
				tab._open = false;
				tab._transition(false);
				tab.removeAttribute('open');
			}
		});
	}

	scrollIntoView(element) {
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}
}

if (!customElements.get('auto-close-tabs')) {
	customElements.define('auto-close-tabs', AutoCloseTabs);
}
const CART_EXPERIMENT_ID = 60231739;
window.activateCartExperiment = () => {
	let experimentsTable = window.ablyft.get('activeExperimentIds');
	const isExperimentActive = !!experimentsTable[CART_EXPERIMENT_ID];
	window['ablyft'] = window['ablyft'] || [];
	if (!isExperimentActive) {
		window['ablyft'].push({
			eventType: 'activatePage',
			pageApiName: 'cart-drawer-has-products',
		});
	}
};
document.addEventListener('variant:add', () => {
	window.activateCartExperiment();
});
document.addEventListener('DOMContentLoaded', () => {
	const productTitleNode = document.querySelector('.product-info__title');
	const productSubtitleNode = document.querySelector('.product-info__title + .product-info__text > .prose > *');
	const productLegalNotice = document.querySelector('[dynamic-legal-notice] > .metafield-rich_text_field > p');
	const urlParams = new URLSearchParams(window.location.search);
	let selectedDynamicContent = window.dynamicContent?.find(
		(content) => content.url_param_value === urlParams.get(content.url_param),
	);
	let alreadySaved = false;
	if (!selectedDynamicContent) {
		const localUrl = JSON.parse(localStorage.getItem('dynamicUrlParam'));
		if (localUrl) {
			selectedDynamicContent = window.dynamicContent?.find(
				(content) => content.url_param === localUrl.paramName && content.url_param_value === localUrl.paramValue,
			);
			alreadySaved = true;
		}
	}
	if (selectedDynamicContent) {
		productTitleNode.textContent = selectedDynamicContent.title;
		productSubtitleNode.textContent = selectedDynamicContent.subtitle;
		productLegalNotice.textContent = selectedDynamicContent.legal_notice;
		const stringifiedContent = JSON.stringify({
			paramName: selectedDynamicContent.url_param,
			paramValue: selectedDynamicContent.url_param_value,
		});
		!alreadySaved && localStorage.setItem('dynamicUrlParam', stringifiedContent);
	}
});

window.updateCartAttributes = (event, checkoutParams) => {
	event.preventDefault();
	const checkoutLink = checkoutParams ? `/checkout?${checkoutParams}` : '/checkout';
	if (!window['ablyft'] || window.abTesting.checkoutExperiments.length === 0 || !ablyft.get) {
		window.location.href = checkoutLink;
	}
	window['ablyft'] = window['ablyft'] || [];
	window['ablyft'].push({
		eventType: 'activatePage',
		pageApiName: 'checkout-page',
	});
	const experimentsTable = ablyft.get('activeExperimentIds');
	const attributes = {};
	window.abTesting.checkoutExperiments.forEach((experiment) => {
		const currentVariationID = experimentsTable[experiment.ablyftExperimentID];
		if (currentVariationID) {
			const variationObject = experiment.variations.find((variation) => variation.variationID === currentVariationID);
			attributes[experiment.cartAttributeKey] = variationObject ? variationObject.cartAttributeValue : '';
		}
	});
	if (Object.keys(attributes).length > 0) {
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			keepalive: true,
			body: JSON.stringify({
				attributes,
			}),
		}).finally(() => {
			window.location.href = checkoutLink;
		});
	} else {
		window.location.href = checkoutLink;
	}
};

class RichAccordion extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.button = this.querySelector('.accordion__toggle--button');
		this.text = this.querySelector('.accordion__content');
		this.open = this.hasAttribute('open');
		this.setInitialHeight();
		this.setContentHeight();
		this.initButton();
		this.setMinHeight();
		window.addEventListener('resize', this.onResize.bind(this));
	}

	setContentHeight() {
		this.maxHeight = this.text.scrollHeight;
	}

	setMinHeight() {
		try {
			if (this.hasAttribute('data-min-height-mobile')) {
				const minHeightMobile = this.getAttribute('data-min-height-mobile');
				if (isNaN(minHeightMobile)) {
					throw new Error('Invalid value for data-min-height-mobile');
				}
				this.text.style.setProperty('--accordion-toggle-min-height-mobile', `${minHeightMobile}rem`);
			}

			if (this.hasAttribute('data-min-height-desktop')) {
				const minHeightDesktop = this.getAttribute('data-min-height-desktop');
				if (isNaN(minHeightDesktop)) {
					throw new Error('Invalid value for data-min-height-desktop');
				}
				this.text.style.setProperty('--accordion-toggle-min-height-desktop', `${minHeightDesktop}rem`);
			}
		} catch (error) {
			console.error(error.message);
		}
	}

	initButton() {
		this.button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	setInitialHeight() {
		const maxHeight = this.open ? this.maxHeight : 0;
		this.text.style.setProperty('--accordion-toggle-height', `${maxHeight}px`);
	}

	onResize() {
		this.setContentHeight();
		this.setInitialHeight();
	}

	toggleAccordion() {
		const newHeight = this.open ? '0px' : `${this.maxHeight}px`;
		this.text.style.setProperty('--accordion-toggle-height', newHeight);
		this.open = !this.open;
		this.setAttribute('aria-expanded', this.open.toString());
	}
}

if (!customElements.get('rich-accordion')) {
	customElements.define('rich-accordion', RichAccordion);
}
